
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Alert, Col, Grid, Row } from 'react-bootstrap';
import './BasicPage.scss';
import ListErrors from './ListErrors';

const alwaysHalf = { lg: 6, md: 6, sm: 6, xs: 6 };
const centeredQuater = { lg: 8, md: 10, sm: 12, xs: 12 };
const leftQuater = { lg: 2, md: 1, sm: 0, xs: 0 };

@inject('authStore')
@observer
class BasicPage extends React.Component<any, any> {
  public render() {
    const props = this.props;
    return (
      <div className="basic-page-container" {...props.containerProps}>
        <Grid className="basic-page">
          <Row>
            <Col {...leftQuater}/>
            <Col {...centeredQuater} className="white-page title">
              <h1>
                {props.title}
              </h1>
            </Col>
          </Row>
        {(this.props.authStore.message || this.props.authStore.errors) &&
          <Row>
          <Col {...leftQuater}/>
          <Col {...centeredQuater}  className="white-page">
              <ListErrors errors={this.props.authStore.errors} />
              {this.props.authStore.message &&
                <Alert bsStyle="success">
                  {this.props.authStore.message}
                </Alert>}
            </Col>
          </Row>}

          <Row>
            <Col {...leftQuater}/>
            <Col {...centeredQuater} className="white-page children">
              {props.children}
            </Col>
          </Row>
          {props.columnOne &&
            <Row>
              <Col {...leftQuater}/>
              <Col {...centeredQuater} className="white-page columns">
                <Row>
                  <Col {...alwaysHalf}>
                    {props.columnOne}
                  </Col>
                  <Col {...alwaysHalf}>
                    {props.columnTwo}
                  </Col>
                </Row>
                </Col>
            </Row>}
        </Grid>
      </div>
    );
  }
}

export default BasicPage;



// WEBPACK FOOTER //
// ./src/components/BasicPage.tsx